

















import { Component, Prop, Vue } from 'vue-property-decorator'

// Component
import DripNaviContent from './DripNaviContent.vue'

@Component({
  components: { DripNaviContent },
})
export default class DripNaviLayout extends Vue {
  @Prop()
  isCollapse!: boolean
}
